<template lang="">
    <v-app style="background-image:linear-gradient(to top, rgb(31, 1, 1), rgb(202 71 71)) !important;">
        <main style="height:100%" v-if="respuesta">
            <v-layout wrap align-center justify-center :style="(ancho < 517) ? 'height:100%' : ''">
                <v-card :class="(ancho < 517) ? '' : 'login-card rounded-xl'" elevation="0" height="100%" :width="(ancho < 517) ? '100%' : '700'" flat raised>
                    <v-row no-gutters>
                        <v-col cols="12" sm="12" md="12">
                            <v-card-title :class="'primary--text'" align-center>
                                <span class="subtitle-1">ID TOOLS SISTEMA DE IDENTIFICACION</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <template v-if="respuesta.persona">
                                 <v-alert text outlined prominent  type="success">
                                        <span class="title"> CARNET VERIFICADO</span><br>
                                        <span>Esta identificacion ha sido verificada correctamente.</span>
                                    </v-alert>
                                <v-card-text v-if="!(ancho < 517)" align="center" justify="center">
                                    <span class="primary--text" style="font-size:50px;">{{respuesta.persona.copeTipo}}</span> <br>
                                    <v-icon color="primary" style="font-size:200px;">mdi-account</v-icon>
                                </v-card-text>
                                <v-card-text v-else align="center" justify="center">
                                    <span class="primary--text" style="font-size:50px;">{{respuesta.persona.copeTipo}}</span> <br>
                                    <v-icon color="primary" style="font-size:200px;">mdi-account</v-icon>
                                </v-card-text>
                                <v-card-text>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <label class="primary--text">NOMBRE: </label>
                                                {{respuesta.persona.copeNombre}}
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6">
                                                <label class="primary--text">IDENT.: </label>
                                                {{respuesta.persona.copeIdentificacion}}
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    
                                </v-card-text>
                            </template>
                            <template v-else-if="respuesta.message">
                                 <v-alert text outlined prominent color="error" type="error">
                                    <span class="title"> PROBLEMA CON EL CODIGO</span><br>
                                    <span>{{respuesta.message}}.</span>
                                </v-alert>
                            </template>
                        </v-col>
                    </v-row>
                </v-card>
            </v-layout>
        </main>
    </v-app>
</template>

<script>
export default {
  data() {
    return {
      url: "sistema/personas/validarQr",
      respuesta: null,
      ancho: (typeof window !== 'undefined') ? window.outerWidth : 517,
    }
  },
  async created() {
    if (this.$route.params.token) {
        try {
             this.respuesta = await this.$apiService.index2(`${this.url}/${this.$route.params.token}`).then(data => data);
        } catch (error) {
            console.log(error)
            this.respuesta = error.response.data;
        }
    }
  },
  mounted: async function() {
    if (typeof window !== 'undefined') {
      window.onresize = () => {
        var widthBrowser = window.outerWidth;
        this.ancho = widthBrowser;
      };
    }
  },
  methods: {

  }
}

</script>

<style>
html,
body {
  background-image: linear-gradient(to top, rgb(31, 1, 1), rgb(202 71 71)) !important;
   width: 100%;
  height: 100%;
}

.login-card {
  margin-top: 2% !important;
}

</style>
